module.exports = __webpack_public_path__ + "static/media/edit_green.b9d25af5.svg";